import {Checkbox, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../../../../design-system/form-field";
import type {SubSettingsFormFieldsType} from "../../types";

export function SubSettingsPurchaseLimitCheckboxFormField({label}: {label: string}) {
  const {control} = useFormContext<SubSettingsFormFieldsType>();

  return (
    <div>
      <Controller
        control={control}
        name="limitUnitsPerTransaction"
        render={({field: {onChange, value, ref}, fieldState: {error}}) => (
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <Checkbox
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              checked={value}
            >
              {label}
            </Checkbox>
            <FormFieldError errorMessage={error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
